export const formatDateTime = (ios: number): string => {
	const date = new Date(ios);

	const day = date.getDate().toString().padStart(2, "0");
	const month = (date.getMonth() + 1).toString().padStart(2, "0");
	const year = date.getFullYear().toString().slice(-2);

	let hours = date.getHours();
	const minutes = date.getMinutes().toString().padStart(2, "0");

	const period = hours >= 12 ? "PM" : "AM";
	hours = hours % 12 === 0 ? 12 : hours % 12;

	return `${day}/${month}/${year}, ${hours
		.toString()
		.padStart(2, "0")}:${minutes} ${period}`;
};
